// extracted by mini-css-extract-plugin
module.exports = {"caption":"Caption_caption__nAosZ"};